import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { api } from "@/lib/api";
import { Trophy, TrendingUp, Users } from "lucide-react";


export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/leaderboard")
      .then(({ data }) => { setRows(data.leaderboard || []); setTotal(data.total || 0); })
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <Navbar/>
      <main className="max-w-6xl mx-auto px-6 py-10">
        <header className="mb-8 flex items-center gap-4">
          <Trophy size={30} className="text-[var(--accent)]"/>
          <div>
            <h1 className="font-display text-4xl text-white">Strategy Leaderboard</h1>
            <p className="text-sm text-[var(--text-secondary)] mt-1">
              Public strategies from the Gallery ranked by backtest net P&L.
              {total > 0 && ` · ${total} eligible`}
            </p>
          </div>
        </header>

        {loading && <p className="text-[var(--text-muted)] font-mono">Loading…</p>}
        {!loading && rows.length === 0 && (
          <div className="card-sharp p-8 text-center" data-testid="leaderboard-empty">
            <Users size={30} className="text-[var(--text-muted)] mx-auto mb-3"/>
            <p className="text-sm text-[var(--text-secondary)]">
              No public strategies with backtest scores yet. Publish yours from the Gallery
              to claim a spot.
            </p>
            <Link to="/gallery" className="btn-primary inline-flex mt-4">Browse Gallery</Link>
          </div>
        )}

        {!loading && rows.length > 0 && (
          <div className="card-sharp overflow-hidden" data-testid="leaderboard-table">
            <table className="w-full text-sm">
              <thead className="text-[10px] uppercase font-mono tracking-widest text-[var(--text-muted)] bg-white/[0.03]">
                <tr>
                  <th className="text-left py-3 pl-4">#</th>
                  <th className="text-left">Strategy</th>
                  <th className="text-left">Author</th>
                  <th className="text-right">Symbol · TF</th>
                  <th className="text-right">Trades</th>
                  <th className="text-right">Win %</th>
                  <th className="text-right">Sharpe</th>
                  <th className="text-right pr-4">Net USD</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={r.strategy_id} className="border-t border-white/5 hover:bg-white/[0.02]"
                    data-testid={`leaderboard-row-${i}`}>
                    <td className="py-3 pl-4 font-mono text-[var(--text-muted)]">
                      {i < 3 ? ["🥇","🥈","🥉"][i] : `#${i+1}`}
                    </td>
                    <td className="text-white">{r.name}</td>
                    <td className="text-[var(--text-secondary)] font-mono text-xs">{r.author}</td>
                    <td className="text-right font-mono text-xs text-[var(--text-muted)]">
                      {r.symbol} · {(r.timeframe || "").replace("PERIOD_","")}
                    </td>
                    <td className="text-right font-mono">{r.trades}</td>
                    <td className="text-right font-mono">{r.win_rate}%</td>
                    <td className="text-right font-mono">{r.sharpe_ratio}</td>
                    <td className={`text-right pr-4 font-mono font-semibold ${
                      r.net_usd >= 0 ? "text-[var(--profit)]" : "text-[var(--loss)]"
                    }`}>
                      {r.net_usd >= 0 ? "+" : ""}${r.net_usd?.toFixed?.(2) ?? r.net_usd}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
}
